import { registerDynamicForm } from "@/utils/dynamicFormRegistry";

const ALISOF_MODULE = "alisof_module";

export function registerDynamicForms() {
  registerDynamicForm({
    modelName: "Contrato",
    modes: ["add", "edit", "view"],
    requiresModule: ALISOF_MODULE,
    customFormKey: "alisof:Contrato",
    autonomous: true,
    component: () => import("./ContratoForm.vue"),
  });
}
